import { render, staticRenderFns } from "./tableDeadlines.vue?vue&type=template&id=321c1cf6&scoped=true"
import script from "./tableDeadlines.vue?vue&type=script&lang=js"
export * from "./tableDeadlines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321c1cf6",
  null
  
)

export default component.exports